import {CustomRoles} from '../helpers/CustomRoles';
import DomainUserView from '../views/DomainUserView';
import CreateUserView from '../views/CreateUserView';
import ContentInfoListView from '../views/ContentInfoListView';
import CreateUpdateContentDialogBox from '../components/CreateUpdateContentDialogBox';
import ContentPublishingPlansView from '../views/ContentPublishingPlansView';
import CreateEditShiftDialog from '../components/CreateEditShiftDialog';
import MySessionsView from '../views/MySessionsView';
import MyHistoryView from '../views/MyHistoryView';
import SwapSessionDialog from "../components/SwapSessionDialog";
import ManageSchedule from '../views/ManageSchedule';
import ParentInfoLookupView from "../views/ParentInfoLookupView";
import DeleteShiftDialog from '../components/availability/DeleteShiftDialog';
import CreateSessionDialog from "../components/CreateSessionDialog";
import DeleteContentDialogBox from '../components/DeleteContentDialogBox';
import ViewSchedule from "../views/ViewSchedule";
import QASchedule from "../views/QASchedule";
import LiveDashboard from "../views/LiveDashboard";
import RefundBookingDialog from "../components/member-lookup/RefundBookingDialog";
import ContentHierarchy from "../views/ContentHierarchy";
import MoveContentInfoDialog from "../components/content-hierarchy/dialogs/MoveContentInfoDialog";
import RemoveContentInfoParentDialog from "../components/content-hierarchy/dialogs/RemoveContentInfoParentDialog";
import MoveContentFolderDialog from "../components/content-hierarchy/dialogs/MoveContentFolderDialog";
import RemoveContentFolderParentDialog from "../components/content-hierarchy/dialogs/RemoveContentFolderParentDialog";
import CreateBookingDialog from '../components/member-lookup/CreateBookingDialog';
import AccreditationHierarchy from "../views/AccreditationHierarchy";
import PublishingPlansHierarchy from "../views/PublishingPlansHierarchy";
import UpdateContentHierarchyDialog from '../components/content-hierarchy/dialogs/UpdateContentHierarchyDialog';
import MakeBookingDialog from '../components/MakeBookingDialog';
import SchedulePlanner from '../views/SchedulePlanner';
import DeleteUserDialogBox from '../components/DeleteUserDialogBox';
import MyAvailability from '../views/MyAvailabilityView';
import HomePage from '../components/HomePage';
import TagManagerView from '../views/TagManagerView';
import ShiftAdminView from "../views/ShiftAdminView";

export default [
    {
        element: <DomainUserView />,
        path: 'users',
        title: 'User Management',
        permission: [
            CustomRoles.Admin
        ],
        children: [
            {
                element: <CreateUserView />,
                path: 'new',
                permission: [
                    CustomRoles.Admin
                ]
            },
            {
                element: <DeleteUserDialogBox />,
                path: 'delete',
                permission: [
                    CustomRoles.Admin
                ]
            }
        ]
    },
    {
        element: <TagManagerView />,
        path: 'tag-manager',
        title: 'Tag Manager',
        permission: [
            CustomRoles.Admin
        ]
    },
    {
        element: <MySessionsView />,
        path: 'mysessions',
        title: 'My Sessions',
        permission: [
            CustomRoles.Teacher
        ]
    },
    {
        element: <MyHistoryView />,
        path: 'myhistory',
        title: 'My History',
        permission: [
            CustomRoles.Teacher
        ]
    },
    {
        element: <MyAvailability />,
        path: 'myavailability',
        title: 'My Availability',
        permission: [
            CustomRoles.Teacher
        ]
    },
    {
        element: <ContentInfoListView />,
        path: 'content-definitions',
        title: 'Content Definitions',
        permission: [
            CustomRoles.Admin,
            CustomRoles.ContentManager
        ],
        children: [
            {
                element: <CreateUpdateContentDialogBox />,
                path: 'new',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <CreateUpdateContentDialogBox />,
                path: 'edit',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <DeleteContentDialogBox />,
                path: 'delete',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            }
        ]
    },
    {
        element: <ContentPublishingPlansView />,
        path: 'content-publishing-plans',
        title: 'Content Publishing Plans',
        permission: [
            CustomRoles.Admin,
            CustomRoles.ContentManager
        ]
    },
    {
        element: <PublishingPlansHierarchy />,
        path: 'publishing-plans-hierarchy',
        title: 'Manage Plans',
        permission: [
            CustomRoles.Admin,
            CustomRoles.ContentManager
        ]
    },
    {
        element: <AccreditationHierarchy />,
        path: 'accreditation-hierarchy',
        title: 'Accreditation Hierarchy',
        permission: [
            CustomRoles.Admin,
            CustomRoles.ContentManager
        ]
    },
    {
        element: <ContentHierarchy />,
        path: 'content-hierarchy',
        title: 'Content Hierarchy',
        permission: [
            CustomRoles.Admin,
            CustomRoles.ContentManager
        ],
        children: [
            {
                element: <MoveContentInfoDialog />,
                path: 'content-info/move',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <RemoveContentInfoParentDialog />,
                path: 'content-info/remove-parent',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <MoveContentFolderDialog />,
                path: 'content-folder/move',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <RemoveContentFolderParentDialog />,
                path: 'content-folder/remove-parent',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <UpdateContentHierarchyDialog />,
                path: 'content-folder/update-content',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <CreateUpdateContentDialogBox />,
                path: 'new',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <CreateUpdateContentDialogBox />,
                path: 'edit',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            },
            {
                element: <DeleteContentDialogBox />,
                path: 'delete',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.ContentManager
                ]
            }
        ]
    },
    {
        element: <ManageSchedule />,
        path: 'schedule',
        title: 'Manage Schedule',
        permission: [
            CustomRoles.Admin,
            CustomRoles.TrafficManager
        ],
        children: [
            {
                element: <CreateEditShiftDialog />,
                path: 'shift/new',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.TrafficManager
                ]
            },
            {
                element: <CreateEditShiftDialog />,
                path: 'shift/edit',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.TrafficManager
                ]
            },
            {
              element: <CreateSessionDialog />,
              path: 'shift/session/create',
              permission: [
                  CustomRoles.Admin,
                  CustomRoles.TrafficManager
              ]
            },
            {
              element: <MakeBookingDialog />,
              path: 'shift/booking',
              permission: [
                  CustomRoles.Admin,
                  CustomRoles.TrafficManager
              ]
            },
            {
                element: <SwapSessionDialog />,
                path: 'shift/session/swap',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.TrafficManager
                ]
            },
            {
                element: <DeleteShiftDialog/>,
                path: 'shift/delete',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.TrafficManager
                ]
            }
        ]
    },

    {
        element: <SchedulePlanner />,
        path: 'plan-schedule',
        title: 'Schedule Planner',
        permission: [
            CustomRoles.Admin,
            CustomRoles.TrafficManager
        ]
    },

    {
        element: <ViewSchedule />,
        path: 'support-schedule',
        title: 'View Schedule',
        permission: [
            CustomRoles.CustomerSupport
        ]
    },

    {
        element: <QASchedule />,
        path: 'qa-schedule',
        title: 'QA Schedule',
        permission: [
            CustomRoles.QA
        ]
    },

    {
        element: <ParentInfoLookupView />,
        path: 'member-lookup',
        title: 'Member Lookup',
        permission: [
            CustomRoles.CustomerSupport,
            CustomRoles.TrafficManager,
            CustomRoles.Admin,
            CustomRoles.QA
        ],
        children: [
            {
                element: <RefundBookingDialog />,
                path: 'refund',
                permission: [
                    CustomRoles.CustomerSupport,
                    CustomRoles.Admin
                ]
            },
            {
                element: <CreateBookingDialog />,
                path: 'booking',
                permission: [
                    CustomRoles.CustomerSupport,
                    CustomRoles.Admin
                ]
            }
        ]
    },

    {
        element: <LiveDashboard />,
        path: 'live-dashboard',
        title: 'Live Dashboard',
        permission: [
            CustomRoles.Admin,
            CustomRoles.TrafficManager,
            CustomRoles.LiveOperations
        ],
        children: [
            {
                element: <SwapSessionDialog />,
                path: 'session/swap',
                permission: [
                    CustomRoles.Admin,
                    CustomRoles.TrafficManager,
                    CustomRoles.LiveOperations
                ]
            }
        ]
    },

    {
        element: <ShiftAdminView />,
        path: 'shift-admin',
        title: 'Shift Admin',
        permission: [
            CustomRoles.Admin,
            CustomRoles.LiveOperations,
            CustomRoles.TrafficManager
        ]
    },

    {
        element: <HomePage/>,
        path: '/',
    }
]